export default "__VITE_ASSET__DUr6Cj06__"